import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { c as e, f as m } from "../../../../create-component-CBAeEoQ6.js";
import { CardTags as f } from "../../CardTags/index.js";
const n = e(
  "TextCardTags",
  m(
    ({ children: r, className: t, ...o }, a) => /* @__PURE__ */ s.jsx(f, { ref: a, className: t, ...o, children: r })
  )
);
export {
  n as TextCardTags
};
//# sourceMappingURL=index.js.map
